import { render, staticRenderFns } from "./Doctor-Payment.vue?vue&type=template&id=4a4a7eff&scoped=true&"
import script from "./Doctor-Payment.vue?vue&type=script&lang=js&"
export * from "./Doctor-Payment.vue?vue&type=script&lang=js&"
import style0 from "./Doctor-Payment.vue?vue&type=style&index=0&id=4a4a7eff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4a7eff",
  null
  
)

component.options.__file = "Doctor-Payment.vue"
export default component.exports